/**
 * カテゴリページ用パンくず自動生成スクリプト
 * 要件:
 *  - 大/中/小カテゴリ階層を DOM から辿って <ol class="breadcrumbs__list"> に項目を挿入する
 *  - 小カテゴリページ: 現在の小 -> 親の中 -> 親の大 の順で表示
 *  - 中カテゴリページ: 現在の中 -> 親の大 の順で表示
 *  - 大カテゴリページ: 現在の大のみ表示（Liquid 側でトップは既に表示済み）
 * 実装方針:
 *  - Liquid 側で <nav class="breadcrumbs" data-current-category-handle data-current-category-level> を埋め込む
 *  - サイドバーのカテゴリツリー (side-collection-search.liquid) の DOM 構造を利用して親を逆引き
 *  - data-unisearch-category-id と data-category-level をキーに特定
 *  - 失敗時は Liquid フォールバック (既存のプレースホルダ li) をそのまま残す
 */
(function () {
  'use strict';

  /**
   * 安全ガード: 二重実行防止
   */
  if (window.__categoryBreadcrumbsInitialized) return;
  window.__categoryBreadcrumbsInitialized = true;

  /**
   * Utility: 文字列正規化（null/undefined 防止）
   * @param {any} v
   * @returns {string}
   */
  function toStr(v) {
    return (v == null ? '' : String(v)).trim();
  }

  /**
   * DOM Ready（DOMContentLoaded を待機せずに既にロード済なら即時実行）
   * Safari 等の互換性を考慮
   * @param {() => void} fn
   */
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /**
   * 指定要素からタイトルテキストを抽出
   * 子の件数表示 (.category-card-count) を除外して純粋タイトルを返却
   * @param {Element|null} el
   * @returns {string}
   */
  function extractTitle(el) {
    if (!el) return '';
    // クローンして件数要素を除去
    const clone = el.cloneNode(true);
    Array.from(clone.querySelectorAll('.category-card-count')).forEach((n) => n.remove());
    return toStr(clone.textContent);
  }

  /**
   * <li> 要素を生成
   * @param {{title:string, url?:string, current?:boolean}} crumb
   * @returns {HTMLLIElement}
   */
  function buildCrumbItem(crumb) {
    const li = document.createElement('li');
    li.className = 'breadcrumbs__item';
    if (crumb.current) {
      const span = document.createElement('span');
      span.className = 'breadcrumbs__current';
      span.textContent = crumb.title;
      li.appendChild(span);
    } else if (crumb.url) {
      const a = document.createElement('a');
      a.className = 'breadcrumbs__link';
      a.href = crumb.url;
      a.textContent = crumb.title;
      li.appendChild(a);
    } else {
      li.textContent = crumb.title;
    }
    return li;
  }

  /**
   * ログ（開発支援。必要に応じてコメントアウト可）
   * @param {...any} args
   */
  function log(...args) {
    // console.debug('[category-breadcrumbs]', ...args);
  }

  // CSS.escape が無い古いブラウザ (非常に稀) 対策: 簡易エスケープ
  if (typeof window.CSS === 'undefined' || typeof window.CSS.escape !== 'function') {
    window.CSS = window.CSS || {};
    window.CSS.escape = function (sel) {
      return String(sel).replace(/"/g, '\\"');
    };
  }

  onReady(() => {
    try {
      const nav = document.querySelector('nav.breadcrumbs[data-current-category-handle]');
      if (!nav) {
        log('breadcrumbs nav not found');
        return;
      }
      const list = nav.querySelector('ol.breadcrumbs__list');
      if (!list) {
        log('breadcrumbs list not found');
        return;
      }

      const currentHandle = toStr(nav.getAttribute('data-current-category-handle'));
      const currentLevelRaw = toStr(nav.getAttribute('data-current-category-level'));
      // Liquid 側では 'TOP' / '2' / '3' を想定。大カテゴリページは 'TOP'
      const level = currentLevelRaw === 'TOP' ? '1' : currentLevelRaw; // 正規化

      if (!currentHandle) {
        log('current handle missing');
        return; // フォールバック維持
      }

      // 既存プレースホルダを削除（トップを除く）
      const placeholderItems = list.querySelectorAll('.js-category-breadcrumbs-placeholder');
      placeholderItems.forEach((p) => p.remove());

      // すでにトップ li は Liquid で出力されている前提
      // ここから後続項目を生成
  const crumbs = []; // {title, url?, current?}

      // side メニューのルートカテゴリ群
      const largeNodes = document.querySelectorAll('.category[data-category-level="1"]');

      /** 現在の中/小カテゴリを指す要素 */
      let currentElement = null;

      if (level === '2') {
        currentElement = document.querySelector(
          `.category-card-count[data-unisearch-category-id="${CSS.escape(currentHandle)}"][data-category-level="2"]`
        );
      } else if (level === '3') {
        currentElement = document.querySelector(
          `.category-card-count[data-unisearch-category-id="${CSS.escape(currentHandle)}"][data-category-level="3"]`
        );
      } else if (level === '1') {
        // 大カテゴリページ: large の header から直接
        currentElement = document.querySelector(
          `.category[data-unisearch-category-id="${CSS.escape(currentHandle)}"][data-category-level="1"] .category-header`
        );
      }

      // 大カテゴリ（level 1）が必要かどうか判定するための参照
      let largeCrumb = null;
      let middleCrumb = null;
      let smallCrumb = null;

      if (level === '1') {
        // 現在の大カテゴリのみ
        if (currentElement) {
          const largeTitle = extractTitle(currentElement);
            // aタグの場合 href, divの場合は data-unisearch-category-id から URL 再構築は困難 -> Liquid で anchor なので通常 a
          const largeLinkEl = currentElement.tagName === 'A' ? currentElement : currentElement.querySelector('a');
          const largeUrl = largeLinkEl ? largeLinkEl.getAttribute('href') : null;
          largeCrumb = { title: largeTitle, url: null, current: true }; // 大カテゴリページは current 表示
        }
      } else if (level === '2') {
        // 中カテゴリ + 親大カテゴリ
        if (currentElement) {
          const middleWrapper = currentElement.closest('.category-card-wrapper');
          if (middleWrapper) {
            // タイトル抽出 (anchor or span 内の .category-card-title)
            const titleHolder = middleWrapper.querySelector('.category-card-title');
            const middleTitle = extractTitle(titleHolder);
            // URL: a があればそれ、現在ページ（spanのみ）なら href 属性から取得
            let middleUrl = null;
            const aEl = middleWrapper.querySelector('a');
            if (aEl) {
              middleUrl = aEl.getAttribute('href');
            } else {
              const spanEl = middleWrapper.querySelector('span[href]');
              middleUrl = spanEl ? spanEl.getAttribute('href') : null;
            }
            middleCrumb = { title: middleTitle, url: middleUrl, current: true };

            // 親大カテゴリ
            const largeRoot = middleWrapper.closest('.category[data-category-level="1"]');
            if (largeRoot) {
              const header = largeRoot.querySelector('.category-header');
              const largeTitle = extractTitle(header);
              const largeUrl = header && header.tagName === 'A' ? header.getAttribute('href') : null;
              largeCrumb = { title: largeTitle, url: largeUrl, current: false };
            }
          }
        }
      } else if (level === '3') {
        // 小カテゴリ + 親中カテゴリ + 親大カテゴリ
        if (currentElement) {
          const smallLi = currentElement.closest('.category-small-item');
          if (smallLi) {
            const smallAnchor = smallLi.querySelector('a');
            const smallTitle = extractTitle(smallAnchor || smallLi);
            const smallUrl = smallAnchor ? smallAnchor.getAttribute('href') : null;
            smallCrumb = { title: smallTitle, url: smallUrl, current: true };

            // 親中カテゴリ
            const middleWrapper = smallLi.closest('.category-card-wrapper');
            if (middleWrapper) {
              const titleHolder = middleWrapper.querySelector('.category-card-title');
              const middleTitle = extractTitle(titleHolder);
              let middleUrl = null;
              const aEl = middleWrapper.querySelector('a');
              if (aEl) middleUrl = aEl.getAttribute('href');
              else {
                const spanEl = middleWrapper.querySelector('span[href]');
                middleUrl = spanEl ? spanEl.getAttribute('href') : null;
              }
              middleCrumb = { title: middleTitle, url: middleUrl, current: false };

              // 親大カテゴリ
              const largeRoot = middleWrapper.closest('.category[data-category-level="1"]');
              if (largeRoot) {
                const header = largeRoot.querySelector('.category-header');
                const largeTitle = extractTitle(header);
                const largeUrl = header && header.tagName === 'A' ? header.getAttribute('href') : null;
                largeCrumb = { title: largeTitle, url: largeUrl, current: false };
              }
            }
          }
        }
      }

      // 生成順序: 大 -> 中 -> 小 （ただし current は最後の階層のみ）
      if (largeCrumb) crumbs.push(largeCrumb);
      if (middleCrumb) crumbs.push(middleCrumb);
      if (smallCrumb) crumbs.push(smallCrumb);

      if (crumbs.length === 0) {
        log('no crumbs constructed; keep fallback');
        return;
      }

  // 既存トップ (ホーム) はそのまま。カテゴリ階層は末尾にまとめて追加する仕様へ変更。
  let insertPoint = null; // append モード
      // フォールバック削除: js-category-breadcrumbs-placeholder クラスを明示的に除去
      list.querySelectorAll('.js-category-breadcrumbs-placeholder').forEach((el)=>el.remove());

      crumbs.forEach((c, idx) => {
        const li = buildCrumbItem(c);
        // ARIA: 現在位置
        if (c.current) {
          const span = li.querySelector('.breadcrumbs__current');
          if (span) span.setAttribute('aria-current', 'page');
        }
        list.appendChild(li); // 末尾へ常に追加
      });

      // 最後の li にクラス付与（既存から除去してから）
      list.querySelectorAll('li.breadcrumbs__item').forEach((li)=>li.classList.remove('breadcrumbs__item--last'));
      const itemsAfter = list.querySelectorAll('li.breadcrumbs__item');
      if(itemsAfter.length){
        itemsAfter[itemsAfter.length-1].classList.add('breadcrumbs__item--last');
      }
    } catch (e) {
      // 失敗時は静かにフォールバック
      console.warn('[category-breadcrumbs] failed', e);
    }
  });
})();
